<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@/app/i18n'
import { passwordChecks } from '@/shared/utils/password'

import AppIcon from './AppIcon.vue'

/**
 * The legacy four-line password checklist (register, set password, change password): an intro line and length,
 * uppercase, number, special character, each ticked live. Standalone when it sits under a confirmation field.
 */
const props = defineProps<{ password: string | null | undefined }>()
const { t } = useI18n()

const checks = computed(() => passwordChecks(props.password))
const lines = computed(() => [
  { id: 'length', met: checks.value.length, text: t('common.validation.passwordMinLength') },
  { id: 'uppercase', met: checks.value.uppercase, text: t('common.validation.passwordUppercase') },
  { id: 'number', met: checks.value.number, text: t('common.validation.passwordNumber') },
  { id: 'special', met: checks.value.special, text: t('common.validation.passwordSpecial') },
])
</script>

<template>
  <div class="mt-2 text-[0.929rem]" data-testid="password-checklist" data-kit="password-checklist">
    <div class="pb-2">{{ t('common.validation.passwordIntro') }}</div>
    <div class="grid grid-cols-1 gap-x-4 sm:grid-cols-2">
      <div v-for="line in lines" :key="line.id" class="flex items-center gap-2" :data-met="line.met">
        <AppIcon :name="line.met ? 'CheckIcon' : 'XIcon'" :class="line.met ? 'text-success' : 'text-danger'" />
        <span :class="{ 'text-success': line.met }">{{ line.text }}</span>
      </div>
    </div>
  </div>
</template>
